import { getEnvironmentInfo } from "@/utils/general";

export default {
  async post(url, data = {}) {
    let myHeaders = new Headers();
    // myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    // myHeaders.append("withCredentials", true);
    // myHeaders.append("Authorization", "Bearer yWKVQCag-WzYs-gsc7-ZBwx-UYMDhtlff8cD");

    let formdata = new FormData();

    if (data) {
      /*additional inputs required by server*/
      const envInfo = getEnvironmentInfo();
      for (let evK in envInfo) {
        formdata.append("inputs[EnvironmentInfo][" + evK + "]", envInfo[evK]);
      }
      formdata.append("inputs[lv_lp_url]", location.href);
      /*end of additional inputs*/

      for (let key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          formdata.append(key, data[key]);
        }
      }
    }

    let requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
      mode: "cors",
      credentials: "include"
    };

    return await fetch(url, requestOptions)
      .then(response => response.json())
      .catch(error => {
        console.log("error", error);
        return { type: "err", Message: error };
      });
  },

  async get(url, data = {}) {
    let finalUrl = new URL(url);
    Object.keys(data).forEach(key =>
      finalUrl.searchParams.append(key, data[key])
    );
    return await fetch(finalUrl)
      .then(response => {
        if (response.status >= 400) throw response;
        return response.json();
      })
      .catch(error => {
        console.log("error", error);
        return { type: "err", Message: error };
      });
  }
};
